module.exports = __webpack_public_path__ + "static/img/187_TO8_2059.8d4bec1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/187_TO8_2059.jpg
// module id = uwLx
// module chunks = 0